export const gridPreferencePanelStateSelector = state => state.preferencePanel;